import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { SessionHealthCheckInfo } from 'app/_models/session-health-check-info.model';
import DateTimeUtils from 'app/_utils/datetime.utils';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'overdue-health-check-list',
  templateUrl: './overdue-health-check-list.component.html'
})
export class OverdueHealthCheckListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() healthChecks: SessionHealthCheckInfo[];
  @Input() emptyStateText: string;
  public healthChecksSorted: SessionHealthCheckInfo[];
  private timerSubscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.timerSubscription = timer(0, DateTimeUtils.MILLISECONDS_IN_A_MINUTE * 1).subscribe(() => {
      this.calculateAllDurations();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['healthChecks'].previousValue !== changes['healthChecks'].currentValue) {
      this.healthChecksSorted = this.healthChecks.sort((a, b) => a.dueTime.getTime() - b.dueTime.getTime());

      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }

      this.timerSubscription = timer(0, DateTimeUtils.MILLISECONDS_IN_A_MINUTE * 1).subscribe(() => {
        this.calculateAllDurations();
      });
    }
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  private calculateAllDurations() {
    const now = new Date();
    this.healthChecks.forEach(healthCheck => {
      healthCheck.calculateDurationSinceDueTimeAndApplyColorClass(now);
    });
  }
}
